import {action, computed, makeObservable, observable, toJS} from 'mobx'
import {CouponService as Service} from 'rest/services/CouponService'
import {CouponQueueService} from 'rest/services/CouponQueueService'
import {Stores} from './index'
import {CouponAddDto} from 'rest/models/CouponAddDto'
import {CouponQueueDetailDto} from 'rest/models/CouponQueueDetailDto'
import {PaginatedResult} from 'rest/types/PaginatedResult'

export class CouponStore {
  stores: Stores
  _couponQueue: PaginatedResult<CouponQueueDetailDto>
  _couponsQueue: PaginatedResult<CouponQueueDetailDto>

  constructor(stores: Stores) {
    this.stores = stores
    makeObservable(this, {
      _couponQueue: observable,
      addCoupon: action,
      _couponsQueue: observable,
      couponsQueue: computed,
      getCouponsQueue: action,
    })
  }

  get couponQueue() {
    return toJS(this._couponQueue)
  }

  get couponsQueue() {
    return toJS(this._couponsQueue)
  }

  getCouponQueue = async (couponId: number) => {
    try {
      const res = await CouponQueueService.getApiCouponQueueGetByCouponId(
        couponId
      )
      if (res.data) {
        this._couponQueue = res.data
      }
    } catch (err) {
      this.stores.ErrorStore.handle(err)
    }
  }

  getCouponsQueue = async (): Promise<
    PaginatedResult<CouponQueueDetailDto>
  > => {
    const storeId = JSON.parse(localStorage.getItem('user'))?.store.id
    if (storeId)
      try {
        const res = await CouponQueueService.getApiCouponQueueGetByMerchantId()
        this._couponsQueue = res
        return this._couponsQueue
      } catch (err) {
        this.stores.ErrorStore.handle(err)
        return this._couponsQueue
      }
  }

  addCoupon = async (payload: CouponAddDto) => {
    try {
      await Service.postApiCouponAdd(payload)
      await this.getCouponsQueue()
      // this._couponQueue = res.data
      return true
    } catch (err) {
      return this.stores.ErrorStore.handle(err)
    }
  }
}
